import {
  SET_CRITERIA_LOGIC,
  ADD_CRITERIA,
  SET_ALL_CRITERIA,
  REMOVE_CRITERIA,
  UPDATE_CRITERIA_BY_COLUMN,
  RESET_CRITERIA
} from '../actionTypes';
import { WorkFlowCriteria } from '../../models';
import { getMaxDisplayNum, updateCriteria } from '../../utils/criterialUtils';

const initialCriteria = {
  criteria: [],
  criteriaLogic: '',
};

const workFlowCriteria = (state = initialCriteria, action) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_CRITERIA:
      const criteriaNumber = getMaxDisplayNum(state.criteria, 'displayNum');
      const newCriteria = new WorkFlowCriteria({ display_num: criteriaNumber + 1 });
      return {
        ...state,
        criteria: [
          ...state.criteria,
          newCriteria
        ]
      };

    case SET_ALL_CRITERIA:
      const { allCriterias } = payload;
      return {
        ...state,
        criteria: allCriterias,
      };

    case REMOVE_CRITERIA:
      const { displayNum } = payload;
      return {
        ...state,
        criteria: state.criteria.filter(c => c.displayNum !== displayNum),
      };

    case UPDATE_CRITERIA_BY_COLUMN:
      const { columnKey, colmunNum, columnValue } = payload;
      const { criteria } = state;
      return {
        ...state,
        criteria: updateCriteria(criteria, columnKey, colmunNum, columnValue),
      };

    case SET_CRITERIA_LOGIC:
      const { logicText } = payload;
      return {
        ...state,
        criteriaLogic: logicText,
      };

    case RESET_CRITERIA:
      return initialCriteria;

    default:
      return state;
  }
};

export default workFlowCriteria;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/flow/reducers/criteria.js